var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnipDarkOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 631 628",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3235,-6984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4516.23,2208.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,858.177,15.9332)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.691312,0,0,0.688,9249.29,48.3826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2535.49,
    y: 7055.83,
    width: 664.898,
    height: 664.898,
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: "78.3px",
      strokeDasharray: "156.6,156.6,156.6,156.6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4507.23,-2153.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2529.59,7055.83L2529.59,6939.95L2529.59,7055.83Z",
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: 54,
      strokeDasharray: "108,108,108,108",
      strokeDashoffset: 108
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4507.23,-2153.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2529.59,7055.83L2413.25,7055.83L2529.59,7055.83Z",
    style: {
      fill: "none",
      stroke: "rgb(242,242,247)",
      strokeWidth: 54,
      strokeDasharray: "108,108,108,108",
      strokeDashoffset: 108
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnipDarkOutline);
export default __webpack_public_path__ + "static/media/snip_dark_outline.092711778b7426af11b4b3a22864126d.svg";
export { ForwardRef as ReactComponent };